import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { saveTokens } from '../auth';

// Config base para a API de autenticação JWT
const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.alumni.uem.mz';
const TOKEN_URL = process.env.REACT_APP_TOKEN_URL || '/api/token/';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state && location.state.from) || '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    setLoading(true);
    try {
      const resp = await fetch(API_BASE + TOKEN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(`Falha de autenticação (${resp.status}): ${text}`);
      }

      const data = await resp.json(); // Esperado: { access, refresh }
      saveTokens(data, !!remember);

      navigate(from || '/', { replace: true });
    } catch (err) {
      console.error(err);
      setError('Não foi possível autenticar. Verifique as credenciais.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA] p-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-md border border-gray-100 p-6">
        <div className="flex items-center gap-3 mb-4">
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <img src={require('../assets/logo/logo-v2.png')} className="w-12 h-12" />
          <div>
            <div className="text-2xl font-bold text-emerald-700">Alumni</div>
            <div className="text-sm text-gray-600">Portal do Graduado</div>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-sm text-gray-700 mb-1">E-mail</label>
            <input
              type="email"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-600"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nome@dominio.com"
              required
            />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Palavra‑passe</label>
            <input
              type="password"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-600"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <div className="flex items-center justify-between">
            <label className="flex items-center gap-2 text-sm text-gray-700">
              <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
              Manter sessão iniciada
            </label>
          </div>
          {error && <div className="text-sm text-red-600">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-emerald-700 hover:bg-emerald-800 text-white py-2 rounded-md disabled:opacity-60"
          >
            {loading ? 'A validar…' : 'Iniciar sessão'}
          </button>
        </form>
      </div>
    </div>
  );
}
